import {useJwtUser} from "@/JWTAuthProvider.tsx";
import {createFileRoute, Navigate, useSearch} from '@tanstack/react-router'
import React from "react";

/**
 * /go/payments — a stable, login-gated address for "set up your payments" (ads, retargeting,
 * emails), which lands on the signed-in user's own Payments tab: /profiles/{uid}/edit/?tab=payments.
 *
 * The gate is _app's: signed out, it goes to /login/?redirect=/go/payments?… and comes back here
 * after sign-in with the query string intact (parseRedirectUrl). Every query parameter is carried
 * through to the final page, so ?src=meta_retarget reaches the attribution capture.
 */
export const Route = createFileRoute('/_app/go/payments')({
    component: RouteComponent,
})

function RouteComponent() {
    const user = useJwtUser();
    const search = useSearch({strict: false}) as Record<string, unknown>;
    if (!user?.uid) {
        return null; // _app has already sent a signed-out visitor to login
    }

    return <Navigate to={`/profiles/${user.uid}/edit/` as any} search={{...search, tab: 'payments'} as any} replace />;
}
